// Derives stable 8-char [A-Z0-9] ids (the shape the RDrive API requires,
// same alphabet as RandomIdGenerator) from a seed string. Used by the P6
// import so the same schedule + P6 ObjectId always maps to the same RDrive
// task id, making re-imports diff as updates instead of delete + recreate.
class DeterministicIdGenerator {
    constructor(length = 8) {
        this.length = length;
        this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        this.usedIds = new Set();
    }

    // FNV-1a 64-bit over the seed's UTF-16 code units.
    hash(seed) {
        const FNV_PRIME = 0x100000001b3n;
        let h = 0xcbf29ce484222325n;
        for (let i = 0; i < seed.length; i++) {
            h ^= BigInt(seed.charCodeAt(i));
            h = (h * FNV_PRIME) & 0xffffffffffffffffn;
        }
        return h;
    }

    encode(value) {
        const base = BigInt(this.characters.length);
        let id = '';
        for (let i = 0; i < this.length; i++) {
            id += this.characters[Number(value % base)];
            value /= base;
        }
        return id;
    }

    // Same seed always yields the same id. If two distinct seeds ever hash to
    // the same id within this generator's lifetime, the later one is re-salted
    // with a counter — deterministically, so a re-import that feeds the seeds
    // in the same order reproduces the same ids.
    generate(seed) {
        let id = this.encode(this.hash(seed));
        for (let salt = 1; this.usedIds.has(id); salt++) {
            id = this.encode(this.hash(`${seed}#${salt}`));
        }
        this.usedIds.add(id);
        return id;
    }
}

export default DeterministicIdGenerator;
